"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ResultsTableBody = _interopRequireDefault(require("./ResultsTableBody"));
var _ResultsTableHeader = _interopRequireDefault(require("./ResultsTableHeader"));
var _helpers = require("./../../utils/helpers");
var _ResultsTableModule = _interopRequireDefault(require("../../scss/ResultsTable.module.scss"));
function ResultsTable(_ref) {
  let {
    columns = [],
    results = [],
    noResultsMsg = 'No results were returned',
    compactLayout = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_ResultsTableModule.default['results-table'], _ResultsTableModule.default['fade-in__wrapper'], compactLayout ? _ResultsTableModule.default['results-table--compact'] : '', compactLayout ? 'results-table--compact' : ''])
  }, /*#__PURE__*/_react.default.createElement(_ResultsTableHeader.default, {
    columns: columns
  }), /*#__PURE__*/_react.default.createElement(_ResultsTableBody.default, {
    columns: columns,
    results: results,
    noResultsMsg: noResultsMsg
  }));
}
var _default = exports.default = ResultsTable;